import { EnumItem } from '@core/models/enum-item.model';
import { BudgetPercentDenominatorEnum } from '@enums/BudgetPercentDenominator';

export const BudgetPercentDenominatorEnumItems: EnumItem<BudgetPercentDenominatorEnum>[] = [
  {
    key: BudgetPercentDenominatorEnum.Project,
    titleKey: `BUDGET_PERCENT_DENOMINATOR.${BudgetPercentDenominatorEnum.Project.toUpperCase()}`
  },
  {
    key: BudgetPercentDenominatorEnum.Parent,
    titleKey: `BUDGET_PERCENT_DENOMINATOR.${BudgetPercentDenominatorEnum.Parent.toUpperCase()}`
  }
];
